import { render, staticRenderFns } from "./bxzl.vue?vue&type=template&id=7c831f4d"
import script from "./bxzl.vue?vue&type=script&lang=js"
export * from "./bxzl.vue?vue&type=script&lang=js"
import style0 from "./bxzl.vue?vue&type=style&index=0&id=7c831f4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports